import {CurrentLocationSlugs} from "@/core/constants/currentLocationSlugs";

async function parseLocationParams(searchParams) {
    let allLocation = {};

    let searchParamsLocation = searchParams.location;

    if (Array.isArray(searchParamsLocation)) {
        searchParamsLocation = searchParamsLocation.filter(Boolean);

        if (searchParamsLocation.length < 1 || !this.checkLocationIsValid(searchParamsLocation.join(','))) {
            return;
        }
    } else if (!this.checkLocationIsValid(searchParamsLocation)) {
        return;
    }

    if (CurrentLocationSlugs.includes(searchParamsLocation)) {
        return this.currentLocationObject()
    } else {
        if (searchParamsLocation || searchParams.postcode) {
            let location = searchParamsLocation;

            if (typeof location === 'string') {
                location = [location];
            }

            const slug = _.compact(location);

            const [err, response] = await to(
                api.seo.getLocationInfo({slug: _.join(slug, ','), postcode: searchParams.postcode})
            );

            if (err) {
                toastr.error('Something went wrong with slug!');
            }

            allLocation = _.get(response, 'data', {});
        } else {
            const [err, response] = await to(api.seo.profileOrSearch(window.location.pathname));

            if (_.get(response, 'data.location')) {
                allLocation = _.get(response, 'data.location');
            }
        }
    }

    allLocation.fromMain = true;

    this.store.commit('setLocation', allLocation);
}

async function currentLocationObject() {
    navigator.geolocation.getCurrentPosition(
        position => {

            const payload = {
                geo_point: {
                    lat: _.get(position, 'coords.latitude', ''),
                    lon: _.get(position, 'coords.longitude', ''),
                },
                is_city: false,
                locale_name: _.get(this, 'translate.home.currentLocation', ''),
                isCurrentLocation: true,
                query: _.get(this, 'translate.home.currentLocation'),
            };

            this.store.commit('setLocation', payload);
        },
        positionError => {
            this.currentLocationError = true;
        },
        {enableHighAccuracy: true}
    );
}

function checkLocationIsValid(searchParamsLocation) {
    const regexFor3PlusLetters = /.*[a-zA-Z].*[a-zA-Z].*[a-zA-Z].*/;

    return regexFor3PlusLetters.test(searchParamsLocation);
}

const data = () => ({
    store: $store,
});

export default {
    data,
    methods: {
        parseLocationParams,
        currentLocationObject,
        checkLocationIsValid,
    },
    computed: {
        ...mapState([
            'location',
            'translate',
        ])
    },
}
